import { connect } from "react-redux";
import { get_users, show_account } from "../actions";
import * as timetravelActions from "../../../reloansys.component/actions/timetravel.actions.actions";

function mapStateToProps(state) {
  return { users: state.users };
}

function mapDispatchToProps(dispatch) {
  return {
    getUsers: (filter) => {
      dispatch(get_users(filter));
    },
    showAccount: (domain, id) => {
      dispatch(show_account(domain, id));
    },
    openBackendView: (path) => {
      dispatch(timetravelActions.set_path(path));
    },
  };
}

export const usersConnector = connect(mapStateToProps, mapDispatchToProps);
